import { all, takeLatest, call, put } from 'redux-saga/effects';
import {
    addFavoriteError,
    addFavoriteRequest,
    addFavoriteSuccess,
    deleteFavoriteError,
    deleteFavoriteRequest,
    deleteFavoriteSuccess,
    getFavoritesError,
    getFavoritesRequest,
    getFavoritesSuccess,
} from './index';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { AxiosError } from 'axios';
import { addFavorite, deleteFavorite, getFavorites } from '@features/favorites/api/favoritesApi';
import { FavoriteObjectEntity, FavoriteObjectId } from '@features/favorites/types';

export function* getFavoritesSaga(action: PayloadAction<{ entity: FavoriteObjectEntity }>): SagaIterator {
    const { entity } = action.payload;

    try {
        const { data } = yield call(getFavorites, entity);
        yield put(getFavoritesSuccess({ entity, data }));
    } catch (error) {
        yield put(getFavoritesError({ entity, error: error as AxiosError }));
    }
}

export function* addFavoriteSaga(
    action: PayloadAction<{ entity: FavoriteObjectEntity; id: FavoriteObjectId }>,
): SagaIterator {
    const { entity, id } = action.payload;

    try {
        yield call(addFavorite, entity, id);
        yield put(addFavoriteSuccess({ entity, id }));
    } catch (error) {
        yield put(addFavoriteError({ entity, error: error as AxiosError }));
    }
}

export function* deleteFavoriteSaga(
    action: PayloadAction<{ entity: FavoriteObjectEntity; id: FavoriteObjectId }>,
): SagaIterator {
    const { entity, id } = action.payload;

    try {
        yield call(deleteFavorite, entity, id);
        yield put(deleteFavoriteSuccess({ entity, id }));
    } catch (error) {
        yield put(deleteFavoriteError({ entity, error: error as AxiosError }));
    }
}

export default function* commonSagaWatcher() {
    yield all([
        takeLatest(getFavoritesRequest.type, getFavoritesSaga),
        takeLatest(addFavoriteRequest.type, addFavoriteSaga),
        takeLatest(deleteFavoriteRequest.type, deleteFavoriteSaga),
    ]);
}
